import React, { useState, useEffect } from 'react';
import AdminServices from '../../services/AdminServices';

function UpdateAdmin({ admin, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    name: '',
    role: '',
    email: '',
    mobileNo: '',
    password: '',
    confirmPassword: '',
    status: '',
  });

  const [errors, setErrors] = useState({
    passwordMismatch: false,
  });

  useEffect(() => {
    if (admin) {
      setFormValues({
        name: admin?.name || '',
        role: admin?.role || '',
        email: admin?.email || '',
        mobileNo: admin?.mobileNo || '',
        password: '',
        confirmPassword: '',
        status: admin?.status || '',
      });
    }
  }, [admin]);

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });

    if (name === 'password' || name === 'confirmPassword') {
      setErrors((prevErrors) => ({ ...prevErrors, passwordMismatch: false }));
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (formValues.password !== formValues.confirmPassword) {
      setErrors({ passwordMismatch: true });
      return;
    }

    try {
      const updatedData = {
        ...formValues,
        password: formValues.password || undefined, // Only send password if it is filled
        confirmPassword: undefined, // Exclude confirmPassword from the payload
      };

      await AdminServices.updateAdmin(admin.id, updatedData);
      alert('Admin details updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update admin details', error);
      alert('Failed to update admin details');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Admin Details</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box-inner">
              <div className="page-details">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="input-field">
                        <label>Role</label>
                        <select
                          className="form-control"
                          value={formValues.role}
                          onChange={handleInputChange}
                          name="role"
                        >
                          <option value="">--Select role--</option>
                          <option value="Admin">Admin</option>
                          <option value="Investor">Investor</option>
                          <option value="User">User</option>
                          <option value="Helper">Helper</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="input-field">
                        <label>Name</label>
                        <input
                          type="text"
                          name="name"
                          value={formValues.name}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter full name"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="input-field">
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          value={formValues.email}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter email address"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="input-field">
                        <label>Phone</label>
                        <input
                          type="text"
                          name="mobileNo"
                          value={formValues.mobileNo}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter phone number"
                          required
                          maxLength={10}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Password</label>
                        <input
                          type="password"
                          name="password"
                          value={formValues.password}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter password"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Confirm Password</label>
                        <input
                          type="password"
                          name="confirmPassword"
                          value={formValues.confirmPassword}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Re-enter password"
                        />
                        {errors.passwordMismatch && (
                          <span style={{ color: 'red', fontSize: '12px' }}>
                            Passwords do not match.
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Status</label>
                        <select
                          className="form-select form-control"
                          value={formValues.status}
                          onChange={handleInputChange}
                          name="status"
                        >
                          <option value="">--Select Status--</option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <button className="site-btn-green float-end mt-0">SAVE & CLOSE</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateAdmin;
